export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-100 scroll-mt-[72px]">
      <div className="max-w-[1440px] mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-6">关于我们</h2>

          <div className="bg-background-50 rounded-2xl border border-background-200/70 p-6 md:p-8 text-left">
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              土豪漫画网成立于2019年，是国内领先的漫画在线免费阅读平台。我们致力于为二次元爱好者提供一个资源丰富、体验流畅、完全免费的漫画阅读空间。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              平台覆盖韩漫、日漫、国漫三大品类，从热血战斗到甜蜜恋爱，从悬疑惊悚到搞笑日常，超过30,000部漫画作品任你挑选。我们拥有一支专业的编辑团队，每日实时追踪全球漫画更新动态，确保读者能在第一时间看到最新连载。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              土豪漫画的最大特色是极致的阅读体验——下拉式流畅阅读模式专为手机优化，无需翻页等待，滑动手指即可沉浸式享受漫画世界。全站绿色安全，无恶意广告，只为让你看得更爽。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed">
              目前平台已累计服务超过800万漫画爱好者，日均活跃读者超过50万。我们始终秉持"好漫画，免费看"的理念，不断优化产品体验，丰富内容库，努力成为你手机里最常用的漫画阅读工具。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}